import React from "react"

export const Quote = ({ children }) => (
  <blockquote className="f4-ns f5 i tc center lh-2 mt3">
    <q className="inline-children">{children}</q>
  </blockquote>
)
